export const QueryParams = {
  SalesArea: 'salesArea',
  ProductGroup: 'productCategory',
} as const;
